export enum BroadcastChannelId {
  OTP_CODE_ENTERED = 'otp-code-entered',
}
